var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5,
    fill: "#FFEFEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4467 37.1767C30.8067 43.78 36.22 49.17 42.8233 52.5533L47.9567 47.42C48.5867 46.79 49.52 46.58 50.3367 46.86C52.95 47.7233 55.7733 48.19 58.6667 48.19C59.95 48.19 61 49.24 61 50.5233V58.6667C61 59.95 59.95 61 58.6667 61C36.7567 61 19 43.2433 19 21.3333C19 20.05 20.05 19 21.3333 19H29.5C30.7833 19 31.8333 20.05 31.8333 21.3333C31.8333 24.25 32.3 27.05 33.1633 29.6633C33.42 30.48 33.2333 31.39 32.58 32.0433L27.4467 37.1767Z",
    fill: "#C2775B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.a53c575e09180473a140274f4d49ea03.svg";
export { ForwardRef as ReactComponent };